import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';

@Component({
  selector: 't4-AmountDialog',
  templateUrl: 'AmountDialog.html',
})
export class AmountDialog extends DialogBase {
  public message: string;
  public amount: number;

  public showComment: boolean = false;

    public sending: boolean = false;

  constructor(public dialogRef: MatDialogRef<AmountDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
    super("AmountDialog");

    this.showComment = data.showComment;
    this.message = data.message;
    this.amount = data.amount;
  }

    public confirm() {
      this.dialogRef.close({ amount: this.amount, message: this.message });
    }
}
